import React from "react";
import Slider from "react-slick";
import { Link } from 'react-router-dom';
import { Skeleton } from "@mui/material";

const TopBrandsSlider: React.FC<{ category: string; loader: boolean; data: { id: string; image: string; name: string }[] }> = ({
    category = "", loader = false, data = []
}) => {
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                },
            },
        ],
    };
    return (
        <Slider {...settings}>
            {loader ?
                Array.from({ length: 5 }).map((_, index) => (
                    <div key={index} className='brand-slide'>
                        <Skeleton variant="rectangular" className="w-full" height="11vh" />
                    </div>
                ))
                :
                data?.map((item, index) => (
                    <div key={index} className="brand-slide">
                        <Link to={`/pharmacy/${category}/${item?.id}/view`}>
                            <img
                                src={`${item?.image}`}
                                alt={item?.name || ""}
                            />
                        </Link>
                    </div>
                ))}
        </Slider>
    );
};

export default TopBrandsSlider;